import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import initVideo, { destoryVideo, extractEmbedSource } from '../../utils/embed';
import s from './ExternalVideo.scss';

const VideoEmbed = ({ url, uid, img = null }) => {
	const videoEmbedSrc = url && extractEmbedSource(url, `${uid}`);

	useEffect(() => {
		initVideo(videoEmbedSrc, uid, { autoplay: 1, loop: 1, mute: 1 });

		return () => {
			destoryVideo(videoEmbedSrc, uid);
		};
	});

	return (
		<div className={s.video}>
			<div className={s.video_inner} id={`iframe-${videoEmbedSrc}-${uid}`}>{ img }</div>
		</div>
	);
};

export default hot(module)(VideoEmbed);
